export default __webpack_public_path__ + "564d3372dbfa7cc9f8316d63d8e46623.svg";